import React from 'react'
import ReactDOM from 'react-dom/client'
import { initSentry } from './config/sentry.jsx'
import App from './App.jsx'
import './index.css'

// Initialize Sentry error monitoring (if enabled via VITE_SENTRY_DSN)
initSentry()

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
